import React from 'react';
import {Button, Modal, Space, Typography} from "antd";
import {useTimer} from "react-timer-hook";
import {ClockCircleOutlined} from "@ant-design/icons";
import {useMutation} from "@tanstack/react-query";
import {getRefreshTokenAPI} from "../../api/AuthAPI";
import axios from "axios";

const SessionTimer = ({ expiryTimestamp }) => {
    const { Text } = Typography;
    const [modal, contextHolder] = Modal.useModal()
    const { restart, seconds, minutes } = useTimer({ expiryTimestamp: expiryTimestamp || new Date(), onExpire: () => expiredModal()});

    const expiredModal = () => {
        modal.error({
            title: 'Login Session Expired',
            content: (
                <div style={{paddingTop: 12, fontSize: 'medium'}}>
                    Your login session has expired. <br/> Please log in again.
                </div>
            ),
            centered: true,
            keyboard: false,
            okButtonProps: { type: 'primary', danger: true },
            autoFocusButton: null,
            onOk: () => {
                window.location.href = window.location.origin;
            }
        })
    }

    const onClickExtendSession = () => {
        extendMutation.mutate({accessToken: sessionStorage.getItem('token'), refreshToken: sessionStorage.getItem('re-token')});
    }

    const extendMutation = useMutation(data => getRefreshTokenAPI(data), {
        onSuccess: res => {
            sessionStorage.setItem('token', res.data.accessToken);
            sessionStorage.setItem('re-token', res.data.refreshToken);
            sessionStorage.setItem('exp', res.data.accessTokenExpiresIn);
            axios.defaults.headers['X-AUTH-TOKEN'] = `Bearer ${res.data.accessToken}`;
            restart(res.data.accessTokenExpiresIn - 1000);
        }
    });

    return (
        <>
            <Space.Compact>
                <Button icon={<ClockCircleOutlined />} type='text' style={{border: '1px solid #d9d9d9', pointerEvents: 'none'}} shape='round'>
                    <Text>{minutes < 10 ? `0${minutes}` : minutes} : {seconds < 10 ? `0${seconds}` : seconds}</Text>
                </Button>
                <Button shape='round' onClick={onClickExtendSession}>
                    Extend
                </Button>
            </Space.Compact>
            {contextHolder}
        </>
    );
};

export default SessionTimer;